import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
export const shareResourceURL = ({ resourceType, resourceId, }) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/sharing/direct/resource-type/${resourceType}/id/${resourceId}`
    : `https://middleware.uat.farther.com/sharing/direct/resource-type/${resourceType}/id/${resourceId}`;
const ShareResourceResponse = z.object({});
export async function shareResourceToPerson(personId, request, config) {
    const { data } = await axios.post(shareResourceURL({
        resourceType: request.resourceType,
        resourceId: request.resourceId,
    }), { personId }, {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            version: "20241029",
            ...("advisorId" in config && { Advisor: config.advisorId }),
            ["idempotency-key"]: `share-${request.resourceType}-${request.resourceId}-${Date.now()}`,
        },
    });
    const decoded = ShareResourceResponse.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "[shareResourceToPerson] returned unexpected data.";
        errorLog(shareResourceToPerson.name, JSON.stringify(decoded.error.issues));
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=shareResourceToPerson.js.map